import { CarregaService } from '../services/carrega_file/carrega.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { format, parse, differenceInDays } from 'date-fns';
import { ApiService } from '../services/contratos/contratos.service';
import { map, take } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-vw-atualiza',
    templateUrl: './vw-atualiza.component.html',
    styleUrls: ['./vw-atualiza.component.css'],
    template: `
    <progressbar [value]="progressValue" [max]="100">{{ progressValue }}%</progressbar>
  `,
    standalone: false
})
export class VwAtualizaComponent {

  progressValue = 0; // Valor atual da barra de progresso
  maxValue = 0; // Valor máximo da barra de progresso
  showProgressBar = false;
  @ViewChild('downloadLink') downloadLink!: ElementRef<HTMLAnchorElement>;
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'items_Operacao_VW';
  items$: Observable<any> | undefined;
  dataLoaded = false;
  jsonData: any;
  sortColumn: string = '';
  sortDirection: number = 1;
  dias_terminal: Date = new Date();
  Freetime: number = 0;
  dados: any[] = [];
  contratos: string[] = [];
  freetime: string[] = [];
  tripcost: string[] = [];
  custoViagem: string = "";
  handling: string[] = [];
  manuseio: string = "";
  demurrage: string[] = [];
  estadia: string = "";
  valorFree: string = '';
  liner: string = "";
  vessel: string = "";
  custoestadia: number = 0;

  constructor(
    private carregaService: CarregaService,
    private http: HttpClient,
    private dynamodbService: ApiService,


  ) { }

  async onFileSelected(event: any) {
    const file: File = event.target.files[0];
    const fileUrl = URL.createObjectURL(file);
    const fileBlob = await fetch(fileUrl).then(response => response.blob());
    const rawData = await this.carregaService.loadFile(fileBlob);
    const inflatedData = this.inflateData(rawData); // Inflar os campos desejados
    this.jsonData = inflatedData;
    this.dataLoaded = true;
    // Chama a função para salvar os dados no API Gateway
  }


  async salvarNoBanco() {
    this.showProgressBar = true;
    // console.log('Item a ser salvo:', this.jsonData);
    this.progressValue = 0;
    this.maxValue = this.jsonData.length;
    const batchSize = 10; // Defina o tamanho máximo para cada lote
    const batches = this.chunkArray(this.jsonData, batchSize); // Fraciona o jsonData em lotes menores

    for (const batch of batches) {
      // Acrescentar o campo "lastupdate" com o valor da data de hoje
      const currentDate = new Date();
      const formattedDate = currentDate.getDate().toString().padStart(2, '0') +
        (currentDate.getMonth() + 1).toString().padStart(2, '0') +
        currentDate.getFullYear().toString();
      for (const item of batch) {
        item.lastupdate = formattedDate;
      }
      // //console.log(batch)
      await this.dynamodbService.salvar(batch, this.query, this.urlAtualiza).subscribe(
        response => {
          this.progressValue = this.progressValue + batch.length;
          //console.log('Resposta do salvamento:', response);
          this.showProgressBar = false;
        },
        error => {
          console.error('Erro ao salvar:', error);
        }
      );
    }
  }


  chunkArray(array: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  async ngOnInit() {

    const key = 'liner'; // Substitua 'propriedade' pelo nome da propriedade que você deseja obter
    const query = 'PowerMathDatabase2'
    const filtro = '';
    this.items$ = (await this.dynamodbService.getItems(query, this.urlConsulta, filtro)).pipe(
      map(data => {
        const parsedData = JSON.parse(data.body); // Parse a string JSON contida em data.body
        return parsedData; // Retorna o objeto JSON parseado
      })
    );

    this.items$.subscribe(
      items => {
        this.contratos = items.map((item: { liner: any; }) => item.liner);
        this.freetime = items.map((item: { freetime: any; }) => item.freetime);
        this.tripcost = items.map((item: { tripcost: any; }) => item.tripcost);
        this.handling = items.map((item: { fsperiod: any; }) => item.fsperiod);
        this.demurrage = items.map((item: { scperiod: any; }) => item.scperiod);

      },
      error => {
        console.error(error);
      }
    );
  }

  testarArquivo(arquivo: File): void {
    this.carregaService.testarArquivoCSV(arquivo).then((estaCorreto) => {
      if (estaCorreto) {
        //console.log('O arquivo CSV está correto.');
      } else {
        //console.log('O arquivo CSV está incorreto.');
      }
    }).catch((erro) => {
      console.error('Erro ao testar o arquivo CSV:', erro);
    });
  }

  excelTimeToHHMMSS(value: any): string[] {
    // Verifica se o valor é uma string contendo '|', aplicando split apenas nesses casos
    if (typeof value === 'string' && value.includes('|')) {
      // console.log('primeiro')
      // console.log(value.split('|').map((v) => v.trim()))
      return value.split('|').map((v) => v.trim());
    }
    // Verifica se é uma string que já está no formato de horário
    if (typeof value === 'string' && /^\d{2}:\d{2}(:\d{2})?$/.test(value)) {
      // console.log('segundo')
      // console.log(value)
      return [value];
    }
    // Trata o caso em que é um número representando tempo
    if (!isNaN(value)) {
      const totalSeconds = Math.round(value * 24 * 60 * 60); // Converte dias em segundos
      const hours = Math.floor(totalSeconds / 3600); // Obtém as horas
      const minutes = Math.floor((totalSeconds % 3600) / 60); // Obtém os minutos restantes
      const seconds = totalSeconds % 60; // Obtém os segundos restantes  
      // Formata como HH:mm:ss
      return [`${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`];
    }
    // Retorna o valor original em um array se nenhum caso for atendido
    return [String(value)];
  }

  inflateData(rawData: any[]): any[] {
    let i = 0;
    return rawData.map((item: any) => {
      let dataDestinoFormatada: Date = new Date();
      let dateObject: Date = new Date();
      // console.log(item['5'])
      const janelas: string[] = this.excelTimeToHHMMSS(item['5']) // Divide o valor da chave '5' usando o caractere '|'
      // const janelas: string[] = item['5'].includes('|'); // Divide o valor da chave '5' usando o caractere '|'
      const janelaData: string[] = [];
      const fornecedor: string[] = item['6'].includes('|') ? item['6'].split('|') : [item['6']]; // Divide o valor da chave '6' usando o caractere '|'
      const destino: string[] = item['15'].includes('|') ? item['15'].split('|') : [item['15']]; // Divide o valor da chave '6' usando o caractere '|'
      const janelaDestinoData: String[] = [];
      const janeladestino: string[] = this.excelTimeToHHMMSS(item['17']) //item['17'].includes('|') ? item['17'].split('|') : [item['17']]; // Divide o valor da chave '6' usando o caractere '|'
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss') + i;
      i = i + 1;
      // //console.log(formattedDate);
      // console.log(typeof item['4']);
      // console.log(item['4']);
      if (typeof item['4'] == "number") {
        dateObject = this.carregaService.formatDate(item['4']);
      // console.log(dateObject);
      } else if (typeof item['4'] == "string") {
        const dateString = item['4'];
        const parts = dateString.split("/"); // Divide a string pelos "/"
        const day = parseInt(parts[0], 10); // Extrai o dia e converte para um número
        const month = parseInt(parts[1], 10) - 1; // Extrai o mês e converte para um número (subtraindo 1, pois os meses são zero-indexados)
        const year = parseInt(parts[2], 10); 
        const date = new Date(year, month, day);
        dateObject = date
      }

      if (typeof item['16'] == "number") {
        dataDestinoFormatada = this.carregaService.formatDate(item['16']);
      } else if (typeof item['16'] == "string") {
        const dateString = item['16'];
        const parts = dateString.split("/"); // Divide a string pelos "/"
        const day = parseInt(parts[0], 10); // Extrai o dia e converte para um número
        const month = parseInt(parts[1], 10) - 1; // Extrai o mês e converte para um número (subtraindo 1, pois os meses são zero-indexados)
        const year = parseInt(parts[2], 10); // Extrai o ano e converte para um número
        // Cria uma nova instância de Date com os valores extraídos
        const date = new Date(year, month, day);
        // console.log(date);
        dataDestinoFormatada = date
      }

      // console.log(dataDestinoFormatada)
      let passos = 0;

      for (let i = 0; i < janelas.length; i++) {
        const horasMinutos = janelas[i];        
        // Garante que cada iteração começa com a mesma data base
        const dataFinal = new Date(dateObject);      
        if (horasMinutos !== null && horasMinutos !== undefined && horasMinutos !== '') {
          const [horas, minutos] = horasMinutos.split(':');          
          // Atualiza as horas e minutos apenas para o horário atual
          dataFinal.setHours(parseInt(horas, 10) - 3, parseInt(minutos, 10), 0, 0);      
          // Adiciona ao array como ISO string
          janelaData[i] = dataFinal.toISOString();          
          passos = passos + 1;
        }
      }      

      for (let i = 0; i < janeladestino.length; i++) {
        const horasMinutos = janeladestino[i];        
        // Garante que cada iteração começa com a mesma data base
        const dataFinal = new Date(dataDestinoFormatada);      
        if (horasMinutos !== null && horasMinutos !== undefined && horasMinutos !== '') {
          const [horas, minutos] = horasMinutos.split(':');          
          // Atualiza as horas e minutos apenas para o horário atual
          dataFinal.setHours(parseInt(horas, 10) - 3, parseInt(minutos, 10), 0, 0);      
          // Adiciona ao array como ISO string
          janelaDestinoData[i] = dataFinal.toISOString();          
          passos = passos + 1;
        }
      }

      console.log(janelaData[0])
      console.log(janelaData[1])
      console.log()

      const inflatedItem: any = {
        'tableName': this.query,
        // 'ID': formattedDate.toString(),
        'ID': item[14] + janelaData[0] ,
        'description': item[3],
        'Passos': passos,
        'Plate': item[14],
        'date': new Date().toString(),
        'Janela 1': janelaData[0], 
        'Janela 2': janelaData[1], 
        'Janela 3': janelaData[2], 
        'Janela 4': janelaData[3], 
        'Fornecedor 1': fornecedor[0], 
        'Fornecedor 2': fornecedor[1], 
        'Fornecedor 3': fornecedor[2], 
        'Fornecedor 4': fornecedor[3], 
        'Destino 1': destino[0], 
        'Destino 2': destino[1], 
        'Destino 3': destino[2], 
        'Destino 4': destino[3], 
        'dataDestino': item['16'],
        'JanelaDestino 1': janelaDestinoData[0], 
        'JanelaDestino 2': janelaDestinoData[1], 
        'JanelaDestino 3': janelaDestinoData[2], 
        'JanelaDestino 4': janelaDestinoData[3], 
        'Weight Loaded': item[10],
        'Cubage': item[12],
        'Volume': item[11],
        'Transport Type': item[13],
        'Total Distance': item[8],
        'Total Cost': item[24]
        // Adicione mais campos conforme necessário
      };
      return inflatedItem;
    });
  }

  sortBy(column: string) {
    if (this.sortColumn === column) {
      // Reverse the sort direction
      this.sortDirection *= -1;
    } else {
      // Set the new sort column and reset the sort direction
      this.sortColumn = column;
      this.sortDirection = 1;
    }
    // Sort the data array based on the selected column and direction
    this.jsonData.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[this.sortColumn];
      const valueB = b[this.sortColumn];
      if (valueA < valueB) {
        return -1 * this.sortDirection;
      } else if (valueA > valueB) {
        return 1 * this.sortDirection;
      } else {
        return 0;
      }
    });
  }

}

